/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../../../../setup";
import * as auth from "../../../../app/modules/auth/redux/AuthRedux";
import { useDispatch } from "react-redux";
import { UserModel } from "services/api/cplauthapi/CPLAuthAPI";

const HeaderUserMenu: FC = () => {
  const user: UserModel | undefined = useSelector<RootState>(({ auth }) => auth.user) as UserModel | undefined;

  const dispatch = useDispatch();
  const logout = () => {
    dispatch(auth.actions.logout());
  };

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3 pt-0">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {user?.firstName} {user?.lastName}
            </div>
            <a data-test-id="user-menu__email-link" href="#" className="fw-bold text-muted text-hover-primary fs-7">
              {user?.emailAddress}
            </a>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <Link data-test-id="user-menu__profile-details-link" to="/Profile" className="menu-link px-5">
          Profile Details
        </Link>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <a data-test-id="user-menu__sign-out-link" onClick={logout} className="menu-link px-5">
          Sign Out
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
